import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { WorkStationType } from '../work-station-type'
import { WorkStationTypeDetailComponent } from '../work-station-type-detail/work-station-type-detail.component'

@Component({
  selector: 'app-work-station-type-detail-side',
  templateUrl: './work-station-type-detail-side.component.html',
  styleUrls: ['./work-station-type-detail-side.component.scss'],
  imports: [WorkStationTypeDetailComponent],
})
export class WorkStationTypeDetailSideComponent {
  private route = inject(ActivatedRoute)
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public workStationType: WorkStationType

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.workStationType = this.route.snapshot.data['type']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
